import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../alert/Alert.css';
import './AppSupport.css';

/**
 * Placeholder for App Support FAQ route until FAQ content is implemented.
 */
export default function AppSupportFaq() {
    const navigate = useNavigate();

    return (
        <div className="alert-home-container">
            <div className="appsupport-top-actions">
                <button
                    type="button"
                    className="appsupport-return-button"
                    onClick={() => navigate('/app/support')}
                >
                    Return to Support Home
                </button>
            </div>
            <div className="alert-home-card">
                <h1 className="alert-home-heading" style={{ textAlign: 'left' }}>FAQ</h1>
                <p className="alert-home-body alert-home-subhead" style={{ textAlign: 'left' }}>
                    FAQ content will be added here.
                </p>
            </div>
        </div>
    );
}
